// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-3102b83d]{display:none}.ingredients__dropdown[data-v-3102b83d]{font-weight:var(--font-weight--semibold);margin:16px 0}.ingredients__dropdown[data-v-3102b83d] .vs__selected{color:var(--c-primary-950)!important;margin:0 0 0 8px}.ingredients__dropdown[data-v-3102b83d] .vs__dropdown-toggle{height:44px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
